import Vue from "vue";
import Vuex from "vuex";
import VueRouter from "vue-router";
import VueMeta from "vue-meta";
import Fragment from "vue-fragment";
import VueMixpanel from "vue-mixpanel";
import App from "./App.vue";
import store from "./store/index";
import routes from "./routes";
import filter from "./filters";
import VueTagsInput from '@johmun/vue-tags-input';
import Hotjar from 'vue-hotjar';
import analyticsEvents from '@/utils/analyticsEvents';
import { eventTracker } from './utils/eventTracker';
import { touchUserSession } from "../new-site-app/utils/sessionManager";
import { setRouteSuperProperties } from "../new-site-app/utils/eventSuperProperties";

export default () => {
    Vue.use(Vuex);
    Vue.use(VueRouter);
    Vue.use(VueMeta);
    Vue.use(Fragment.Plugin);

    Vue.use(Hotjar, {
        id: process.env.MIX_APP_HOTJAR_ID
    })

    Vue.use(VueMixpanel, {
        token: process.env.MIX_MIXPANEL_PROJECT_TOKEN,
        config: {
            persistence: 'localStorage',
        },
    });

    Vue.directive('event-track', {
        bind: (el, binding) => {
            el.addEventListener('click', () => {
                const modifiers = Object.keys(binding.modifiers);
                switch (modifiers.length) {
                    case 0:
                        eventTracker(analyticsEvents[binding.arg], binding.value);
                        break;
                    case 1:
                        eventTracker(analyticsEvents[binding.arg][modifiers[0]], binding.value);
                        break;
                    default:
                        console.error("The 'event-track' directive doesn't support more than one modifier");
                }
            });
        },
    })

    Vue.use(filter);
    Vue.component('vue-tags-input', VueTagsInput)

    App.store = new Vuex.Store(store);

    App.router = new VueRouter({
        mode: "history",
        routes,
    });

    App.router.beforeEach((to, from, next) => {
        touchUserSession();
        setRouteSuperProperties(to);
        Vue.nextTick(() => {
            eventTracker(analyticsEvents.pageView, { previous_page: from.path });
        });
        next();
    });

    return new Vue(App);
};